<template>
  <div>
    <div class="py-5 flex justify-between">
      <form @submit.prevent="submitSearch()">
        <vs-input icon-no-border placeholder="Search" v-model="searchQuery" class="input-rounded-full" icon="icon-search" icon-pack="feather" />
      </form>
      <vs-button @click="$router.push('/org_management/add_sites')" class="float-right mb-5">Add Site</vs-button>
    </div>

    <vs-table stripe :data="lists">
    <template slot="thead">
      <vs-th>No</vs-th>
      <vs-th class="text-left">Sites</vs-th>
      <vs-th class="text-center">Code Auth</vs-th>            
      <vs-th class="text-center">Servers</vs-th>
      <vs-th class="text-center">Connected</vs-th>
      <vs-th class="text-right">Action</vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="indextr">
          {{ indextr + 1 }}
        </vs-td>

        <vs-td class="text-left" :data="tr.name">
          {{ tr.name }}
        </vs-td>

        <vs-td class="text-center" :data="tr.name">
          {{ tr.codeAuth }}
        </vs-td>

        <vs-td class="text-center" :data="tr.name">
          {{ tr.ipAddress }}
        </vs-td>

        <!-- <vs-td class="text-center" :data="tr.ip">
          {{ tr.cameras }}
        </vs-td> -->

        <vs-td class="text-center" :data="tr.ip">
          {{ tr.onOff == '1' ? 'Yes' : 'No' }}
        </vs-td>

        <vs-td class="text-right">
          <div class="flex justify-end">
            <vs-tooltip text="Edit">
              <a href="" @click.prevent="navigateToEditForm(tr.id)">
                <feather-icon icon="EditIcon" svgClasses="icon" />
              </a>
            </vs-tooltip>
            <vs-tooltip text="Delete">
              <a href="" @click.prevent="conformDelete(tr.id)">
                <feather-icon icon="Trash2Icon" svgClasses="icon" />
              </a>
            </vs-tooltip>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      selectedId: '',
      searchQuery: '',
      lists: []
      // lists: [
      //   {
      //     "siteId" : 1,
      //     "siteName" : "POS LOGISTIC",
      //     "ipaddress" : "xxx.xx.xx.xxx",
      //     "username" : "adminCCTV",
      //     "password" : "admin",
      //     "servers": 3,
      //     "cameras": 21,
      //     "activationDate": "2022-07-21",
      //     "status": 1
      //   },
      //   {
      //     "siteId" : 2,
      //     "siteName" : "STS - OFFICE",
      //     "ipaddress" : "xxx.xx.xx.xxx",
      //     "username" : "adminCCTV",
      //     "password" : "admin",
      //     "servers": 1,
      //     "cameras": 8,
      //     "activationDate": "2022-07-21",
      //     "status": 1

      //   },
      //   {
      //     "siteId" : 3,
      //     "siteName" : "STS - Enginering",
      //     "ipaddress" : "xxx.xx.xx.xxx",
      //     "username" : "adminCCTV",
      //     "password" : "admin",
      //     "servers": 2,
      //     "cameras": 152,
      //     "activationDate": "2022-05-22",
      //     "status": 1
      //   },
      // ],
    };
  },
  mounted() {
    this.$store.dispatch('saveSiteForm', null)
    this.getSiteLists()
  },
  methods: {
    submitSearch() {
      this.getSiteLists()
    },
    navigateToEditForm(id) {
      this.$store.dispatch('updateCurrentSite', id)

      this.$router.push(`/org_management/update_sites/${id}`)
    },
    getSiteLists() {
      this.$vs.loading()
      api.sites({
        siteName: this.searchQuery
      })
      .then(result => result.data)
      .then(data => {
        if(data.status) {
          this.lists = data.data
          this.$store.dispatch("updateSiteLists", data.data);
        }
        this.$vs.loading.close()
      })
      .catch((e) => {
        console.log(e)
        this.$vs.loading.close()
      });
    },
    conformDelete(id){
      this.selectedId = id
      this.$vs.dialog({
        color: 'danger',
        title: `Confirm Delete`,
        text: 'Are you sure will delete this data?.',
        accept: this.doDelete
      })
    },
    doDelete() {
      this.$vs.loading()
      api.deleteSite({id: this.selectedId})
      .then(result => result.data)
      .then(data => {
        console.log(data)
        this.selectedId = ''

        this.$vs.notify({
            title:'Success',
            text:'Delete data success',
            color:'success',
            position:'top-right'
        })
        
        this.$vs.loading.close()
      })
      .finally(() => {
        this.getSiteLists()
      })
      .catch((e) => {
        console.log(e)
        this.selectedId = ''

        this.$vs.notify({
            title:'Failed',
            text:'Delete data failed',
            color:'danger',
            position:'top-right'
        })
        
        this.$vs.loading.close()
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.icon {
  margin: 0 5px;
}
.text-center::v-deep .vs-table-text {
  justify-content: center;
}
.text-right::v-deep .vs-table-text {
  justify-content: flex-end;
}
</style>
